import { useMemo } from 'react'
import { createStore } from 'jotai'
import { creditTokenApiKeyAtom, creditTokenPublicKeyAtom, isProductionAtom } from '@!/atoms/paymentAtom'

/**
 * ExternalPayment用の設定フック
 * JotaiストアにGMOクレジットトークンAPI設定を登録
 * @param {Object} settings - 設定値
 * @param {string} settings.creditTokenApiKey - GMO クレジットトークンAPI用のAPIキー
 * @param {string} settings.creditTokenPublicKey - GMO クレジットトークンAPI用の公開鍵
 * @param {boolean} settings.isProduction - 本番環境フラグ
 * @returns {Object} Jotaiストア
 */
export const useExternalPaymentSettings = ({ creditTokenApiKey, creditTokenPublicKey, isProduction }) => {
  // useMemoでストアをメモ化し、再レンダリング時の再作成を防ぐ
  // creditTokenApiKey, creditTokenPublicKey, isProductionは初期化パラメータであり、動的に変更されない
  const store = useMemo(() => {
    const newStore = createStore()
    newStore.set(creditTokenApiKeyAtom, creditTokenApiKey)
    newStore.set(creditTokenPublicKeyAtom, creditTokenPublicKey)
    newStore.set(isProductionAtom, isProduction)
    return newStore
  }, [])

  return store
}
